import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SkillPathEntryFieldsFragment = { __typename?: 'GuideLevel', id: string, name: string, code?: string | null, guideId: string, subjectId: string, onStudentsSkillPaths?: boolean | null, skillPathStatus?: Types.SkillPathStatus | null, skillPathMinDueDate?: any | null, skillPathMaxDueDate?: any | null, skillPathMinStartDate?: any | null, skillPathMaxStartDate?: any | null, skillPathStudentCount: number, skillPathCompletedStudentCount: number, openMinDueDate?: any | null, openMaxDueDate?: any | null, scheduledMinStartDate?: any | null, scheduledMaxStartDate?: any | null, parent?: { __typename?: 'GuideLevel', id: string, parent?: { __typename?: 'GuideLevel', id: string } | null } | null };

export type SkillPathEntriesQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  status?: Types.InputMaybe<Types.SkillPathStatus>;
  isAllStatuses: Types.Scalars['Boolean']['input'];
  includeDueDates: Types.Scalars['Boolean']['input'];
  includeStartDates: Types.Scalars['Boolean']['input'];
  filter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.GuideLevelSortInput>> | Types.InputMaybe<Types.GuideLevelSortInput>>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  asEducatorId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type SkillPathEntriesQuery = { __typename?: 'RootQueryType', skillPathEntries?: { __typename?: 'PageOfGuideLevel', hasNextPage: boolean, results?: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null, guideId: string, subjectId: string, onStudentsSkillPaths?: boolean | null, skillPathStatus?: Types.SkillPathStatus | null, skillPathMinDueDate?: any | null, skillPathMaxDueDate?: any | null, skillPathMinStartDate?: any | null, skillPathMaxStartDate?: any | null, skillPathStudentCount: number, skillPathCompletedStudentCount: number, openMinDueDate?: any | null, openMaxDueDate?: any | null, scheduledMinStartDate?: any | null, scheduledMaxStartDate?: any | null, parent?: { __typename?: 'GuideLevel', id: string, parent?: { __typename?: 'GuideLevel', id: string } | null } | null }> | null } | null };

export type SkillPathEntryStatusCountsQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.GuideLevelSortInput>> | Types.InputMaybe<Types.GuideLevelSortInput>>;
  allFilter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  openFilter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  closedFilter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  scheduledFilter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  asEducatorId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type SkillPathEntryStatusCountsQuery = { __typename?: 'RootQueryType', all?: { __typename?: 'PageOfGuideLevel', count?: number | null } | null, open?: { __typename?: 'PageOfGuideLevel', count?: number | null } | null, closed?: { __typename?: 'PageOfGuideLevel', count?: number | null } | null, scheduled?: { __typename?: 'PageOfGuideLevel', count?: number | null } | null };

export const SkillPathEntryFieldsFragmentDoc = gql`
    fragment SkillPathEntryFields on GuideLevel {
  id
  name
  code
  guideId
  subjectId
  onStudentsSkillPaths
  skillPathStatus @include(if: $isAllStatuses)
  skillPathMinDueDate(status: $status) @include(if: $includeDueDates)
  skillPathMaxDueDate(status: $status) @include(if: $includeDueDates)
  skillPathMinStartDate(status: $status)
  skillPathMaxStartDate(status: $status) @include(if: $includeStartDates)
  openMinDueDate: skillPathMinDueDate(status: OPEN) @include(if: $isAllStatuses)
  openMaxDueDate: skillPathMaxDueDate(status: OPEN) @include(if: $isAllStatuses)
  scheduledMinStartDate: skillPathMinStartDate(status: SCHEDULED) @include(if: $isAllStatuses)
  scheduledMaxStartDate: skillPathMaxStartDate(status: SCHEDULED) @include(if: $isAllStatuses)
  skillPathStudentCount
  skillPathCompletedStudentCount
  parent {
    id
    parent {
      id
    }
  }
}
    `;
export const SkillPathEntriesDocument = gql`
    query SkillPathEntries($classroomIds: [ID!], $status: SkillPathStatus, $isAllStatuses: Boolean!, $includeDueDates: Boolean!, $includeStartDates: Boolean!, $filter: GuideLevelFilterInput, $sort: [GuideLevelSortInput], $limit: Int, $offset: Int, $asEducatorId: ID) {
  skillPathEntries(
    classroomIds: $classroomIds
    filter: $filter
    sort: $sort
    limit: $limit
    offset: $offset
    asEducatorId: $asEducatorId
  ) {
    hasNextPage
    results {
      ...SkillPathEntryFields
    }
  }
}
    ${SkillPathEntryFieldsFragmentDoc}`;

/**
 * __useSkillPathEntriesQuery__
 *
 * To run a query within a React component, call `useSkillPathEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillPathEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillPathEntriesQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *      status: // value for 'status'
 *      isAllStatuses: // value for 'isAllStatuses'
 *      includeDueDates: // value for 'includeDueDates'
 *      includeStartDates: // value for 'includeStartDates'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      asEducatorId: // value for 'asEducatorId'
 *   },
 * });
 */
export function useSkillPathEntriesQuery(baseOptions: Apollo.QueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables> & ({ variables: SkillPathEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>(SkillPathEntriesDocument, options);
      }
export function useSkillPathEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>(SkillPathEntriesDocument, options);
        }
// @ts-ignore
export function useSkillPathEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>;
export function useSkillPathEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntriesQuery | undefined, SkillPathEntriesQueryVariables>;
export function useSkillPathEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>(SkillPathEntriesDocument, options);
        }
export type SkillPathEntriesQueryHookResult = ReturnType<typeof useSkillPathEntriesQuery>;
export type SkillPathEntriesLazyQueryHookResult = ReturnType<typeof useSkillPathEntriesLazyQuery>;
export type SkillPathEntriesSuspenseQueryHookResult = ReturnType<typeof useSkillPathEntriesSuspenseQuery>;
export type SkillPathEntriesQueryResult = Apollo.QueryResult<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>;
export const SkillPathEntryStatusCountsDocument = gql`
    query SkillPathEntryStatusCounts($classroomIds: [ID!], $sort: [GuideLevelSortInput], $allFilter: GuideLevelFilterInput, $openFilter: GuideLevelFilterInput, $closedFilter: GuideLevelFilterInput, $scheduledFilter: GuideLevelFilterInput, $asEducatorId: ID) {
  all: skillPathEntries(
    classroomIds: $classroomIds
    filter: $allFilter
    sort: $sort
    limit: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  open: skillPathEntries(
    classroomIds: $classroomIds
    filter: $openFilter
    sort: $sort
    limit: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  closed: skillPathEntries(
    classroomIds: $classroomIds
    filter: $closedFilter
    sort: $sort
    limit: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  scheduled: skillPathEntries(
    classroomIds: $classroomIds
    filter: $scheduledFilter
    sort: $sort
    limit: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
}
    `;

/**
 * __useSkillPathEntryStatusCountsQuery__
 *
 * To run a query within a React component, call `useSkillPathEntryStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillPathEntryStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillPathEntryStatusCountsQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *      sort: // value for 'sort'
 *      allFilter: // value for 'allFilter'
 *      openFilter: // value for 'openFilter'
 *      closedFilter: // value for 'closedFilter'
 *      scheduledFilter: // value for 'scheduledFilter'
 *      asEducatorId: // value for 'asEducatorId'
 *   },
 * });
 */
export function useSkillPathEntryStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>(SkillPathEntryStatusCountsDocument, options);
      }
export function useSkillPathEntryStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>(SkillPathEntryStatusCountsDocument, options);
        }
// @ts-ignore
export function useSkillPathEntryStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>;
export function useSkillPathEntryStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntryStatusCountsQuery | undefined, SkillPathEntryStatusCountsQueryVariables>;
export function useSkillPathEntryStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>(SkillPathEntryStatusCountsDocument, options);
        }
export type SkillPathEntryStatusCountsQueryHookResult = ReturnType<typeof useSkillPathEntryStatusCountsQuery>;
export type SkillPathEntryStatusCountsLazyQueryHookResult = ReturnType<typeof useSkillPathEntryStatusCountsLazyQuery>;
export type SkillPathEntryStatusCountsSuspenseQueryHookResult = ReturnType<typeof useSkillPathEntryStatusCountsSuspenseQuery>;
export type SkillPathEntryStatusCountsQueryResult = Apollo.QueryResult<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>;